import { useMemo } from 'react';
import sortBy from 'lodash/sortBy';

import { useResponseBaseHeight } from '../response.hooks';
import { useSimpleModalState } from 'approot/shared/modal/modal.hooks';
import { ComponentOverlayWrapper } from '../../shared/component-overlay/component-overlay.style';
import { getComponentSelectorId } from '../../shared/logic/get-component-selector-id';
import { getSubActivityInstructionAsText } from '../../sub-activity/sub-activity.utils';
import ComponentOverlaySample from '../../shared/component-overlay/component-overlay-sample';
import SubActivityView from '../../sub-activity/sub-activity-view';
import { ViewProps } from '../response.constants';
import * as Styled from '../response-view.style';
import ResponseFieldReadonly from '../response-field-readonly';
import ResponseViewSampleAnswerModal from './response-view-sample-answer-modal';
import { SampleProps } from '../../sample/activity-sample.constants';

const ResponseViewSample = (props: ViewProps & SampleProps) => {
  const { id, properties, subActivityProperties } = props;

  const baseHeight = useResponseBaseHeight();
  const { isVisible, openModal, closeModal } = useSimpleModalState();

  const sortedFields = useMemo(
    () => sortBy(properties.textResponse.fields, 'sort'),
    [properties.textResponse.fields]
  );

  return subActivityProperties?.activityComponentId ? (
    <SubActivityView subActivityDetails={subActivityProperties}>
      {isVisible && (
        <ResponseViewSampleAnswerModal {...props} onClose={closeModal} />
      )}
      <ComponentOverlayWrapper>
        <Styled.ResponseViewContainer id={getComponentSelectorId(id)}>
          {sortedFields.map(field => {
            return (
              <Styled.ResponseFieldWrapper key={field.itemId}>
                <ResponseFieldReadonly
                  answer={undefined}
                  baseHeight={baseHeight}
                  field={field}
                />
              </Styled.ResponseFieldWrapper>
            );
          })}
        </Styled.ResponseViewContainer>
        <ComponentOverlaySample
          ariaLabel={`Type your answer to: ${getSubActivityInstructionAsText(
            subActivityProperties?.instructions
          )}`}
          onClick={openModal}
        />
      </ComponentOverlayWrapper>
    </SubActivityView>
  ) : null;
};

export default ResponseViewSample;
